import React from 'react'
import { Icon } from '@iconify/react';



export const botNavbar = [ 
    {
        icon: <Icon icon="uiw:home" />,
        link: "/",
        title: "Trading Bot",
        lists: [
            {
                link: "/",
                title: "Home",
                type: "select",
                options: [
                    {
                        title: "Professionals",
                        link: "/professionals",
                        icon: <Icon icon="healthicons:city-worker-outline" />,
                    },
                ]
            },

            // {
            //     link: "#",
            //     title: "Solution",
            //     type: "select",
            //     options: [
            //         {
            //             title: "Professionals",
            //             link: "/professionals",
            //             icon: <Icon icon="healthicons:city-worker-outline" />,
            //         },
            //     ]
            // },
            {
                link: "/pricing",
                title: "Pricing",
                type: "select",
                options: [
                    {
                        title: "Investment Sales",
                        link: "/investments-sales",
                        icon: <Icon icon="gis:home" />,
                    },
                ]
            },
            {
                link: "/market-place",
                title: "Marketplace",
                type: "select",
                options: [],
            },
            {
                link: "/learn",
                title: "Learn",
                type: "select",
                options: [
                    {
                        title: "Block management",
                        link: "/",
                        icon: <Icon icon="mingcute:building-3-line" />,
                    },
                ]
            },
            {
                link: "/contact",
                title: "Contact Us",
                type: "select",
                options: [],
            },
            {
                link: "/about",
                title: "About",
                type: "select",
                options: [
                    {
                        title: "Developments & Maintainance",
                        link: "/invest-development",
                        icon: <Icon icon="et:tools" />,
                    },
                ]
            },
        ]
    }
]

export const tradeHero = [
    {
        title:"The world’s most customizable crypto trading bot",
        info: "Free up time for things that matter",
        img: "images/trade_main.avif"
    },
]

export const latestArticles = [
    {
        title: "Which feature would you like to see next in our mobile app?",
        img: "/images/blog1.jpeg"
    },
    {
        title: "A Comprehensive Guide to Buying and Selling Altcoins",
        img: "/images/blog2.jpeg"
    },
    {
        title: "A Comprehensive Guide to Buying and Selling Altcoins",
        img: "/images/blog4.jpeg"
    },
    {
        title: "A Comprehensive Guide to Buying and Selling Altcoins",
        img: "/images/blog5.jpeg"
    },
]

export const testimonials = [
    {
        icon: "",
        title: "Trailing features",
        info: "Follow the price movement and sell/buy automatically when the price goes in another direction."
    },
    {
        icon: "",
        title: "Trading Bots",
        info: "Copy other traders easily, or trade automatically with our unique trading A.I."
    },
    {
        icon: "",
        title: "Pro Tools",
        info: "Follow the price movement and sell/buy automatically when the price goes in another direction."
    },
    {
        icon: "",
        title: "Trailing features",
        info: "Use tools like DCA, Market-Making, Arbitrage or our own free of charge charting software."
    },
]

export const testimo = [
    {
        img: "images/bot_12.svg",
        bg: "bg-[#1e2738]",
        title: "Grid Bot",
        info: "Automate buy-low and sell-high across a price range — ideal for sideways markets.",
    },
    {
        img: "images/bot_13.svg",
        bg: "bg-[#1e2738]",
        title: "Scheduled Bot",
        info: "Run DCA and time-based trades on a cron schedule without watching the clock.",
    },
    {
        img: "images/bot_14.svg",
        title: "Algo Bot",
        bg: "bg-[#1e2738]",
        info: "Combine monitors, conditions, and order templates into full buy/sell strategies.",
    },
    {
        img: "images/bot_15.png",
        title: "Live Dashboard",
        bg: "bg-[#1e2738]",
        info: "Track wallets, orders, and bot activity in real time from one unified dashboard.",
    },
]

export const traderTestimonials = [
    {
        title: 'Sarah K.',
        role: 'Part-time trader',
        info: 'I set up a grid bot on ETH in under ten minutes. It runs while I\'m at work and I check the dashboard each evening.',
    },
    {
        title: 'Daniel M.',
        role: 'Futures trader',
        info: 'The unified setup wizard made it easy to link monitors and order templates. My algo bot has been running smoothly for weeks.',
    },
    {
        title: 'Priya R.',
        role: 'DCA investor',
        info: 'Scheduled bots let me dollar-cost average into BTC every Monday without setting alarms. Simple and reliable.',
    },
    {
        title: 'James L.',
        role: 'Swing trader',
        info: 'Backtesting before going live saved me from a bad RSI strategy. The limits are clear and the UI keeps everything organized.',
    },
    {
        title: 'Elena V.',
        role: 'Bot enthusiast',
        info: 'I run three grid bots on different pairs. NeuraTrader handles the order flow — I just manage ranges and wallet balance.',
    },
    {
        title: 'Tom H.',
        role: 'New to crypto',
        info: 'The Learn guides walked me through each bot type. I started with a small grid on spot and grew from there.',
    },
];

export const bot_ratings = [
    {
        icon: <Icon icon="uis:star" />,
        title: "“Three house viewings from ben”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Patrik"
    },
    {
        icon: <Icon icon="uis:star" />,
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Anonymous"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“Three house viewings from ben”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Victor"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“Three house viewings from ben”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Anonymous"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“Three house viewings from ben”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Patrik"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“Three house viewings from ben”",
        name: "Anonymous"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“Three house viewings from ben”",
        para: "Amazing letting agents. Joe was very helpful and professional, Chelsea answered our queries patiently. Thank you Danhamz",
        name: "Patrik"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“Three house viewings from ben”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Patrik"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“Three house viewings from ben”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Patrik"
    },{
        icon: <Icon icon="uis:star" />,
        title: "“Three house viewings from ben”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Patrik"
    },
]

export const testimonial3 = [
    {
        img: "images/bot_12.svg",
        title: "Dollar Cost Averaging",
        info: "Dollar Cost Averaging allows you to double or triple up on an investment that went sour. By using DCA, you can mitigate any potential bags by bringing down the weighted average price.",
    },
    {
        img: "images/bot_13.svg",
        title: "Scheduled trading",
        info: "Automate recurring entries and exits on a timetable you control."
    },
    {
        img: "images/bot_14.svg",
        title: "Blocked",
        info:"Respond to the rise and fall of currencies and make sure that you respond to early signs of bear markets. Create customized actions ranging from notifications to sell orders to ensure your portfolio is safe 24/7."
    },
]

export const traderCategory = [
    {
        icon: <Icon icon="fontisto:wallet" />,
        title: "Online Wallet",
        info: "Start trading with our easy-to-use trading bot. 100% free."
    },
    {
        icon: <Icon icon="vaadin:coin-piles" />,
        title: "Send Money",
        info: "Copy other traders easily, or trade automatically with our unique trading A.I."
    },
    {
        icon: <Icon icon="formkit:dollar" />,
        title: "Subscription Plans",
        info: "Start trading with our easy-to-use trading bot. 100% free.",
        link: "/subscription"
    },
    {
        icon: <Icon icon="mingcute:binance-coin-bnb-fill" />,
        title: "Coin Mining",
        info: "Start trading with our easy-to-use trading bot. 100% free."
    },

]

export const affiliateProgram = [
    {
        title: "Earn revenue by joining our affiliate program",
        info: "Turn your website/blog/youtube or social media into a passive income powerhouse by promoting worlds leading trading bot! Our affiliate program allows you to make a commission on a monthly basis as long as your customers are active. Join the fastest growing and most energetic social trading platform",
        img: "images/bot_15.png"
    }
]

export const botFooter = [
    {
        title: "Follow us",
        Links: [
            {
                icon: 'https://static.vecteezy.com/system/resources/previews/018/930/415/non_2x/instagram-logo-instagram-icon-transparent-free-png.png',
                title: "@neuratrader",
                url: "https://instagram.com/neuratrader"
            },
            {
                icon: 'https://allpngfree.com/apf-prod-storage-api/storage/thumbnails/twitter-new-logo-png-transparent-images-thumbnail-1697953256.jpg',
                title: "@neuratrader",
                url: "https://x.com/neuratrader"
            },
        ],
    },
];
export const experienceTrade = [
    {
        title:"Trust",
        icon: <Icon icon="mdi:account-tick" />,
        info:"Neuratrader works closely together with exchanges and regulators.",
    },
    {
        title:"Security",
        icon: <Icon icon="teenyicons:shield-tick-solid" />,
        info:"Your account is protected by industry-leading security protocols",
    },
    {
        title:"Privacy",
        icon: <Icon icon="ic:round-lock" />,
        info:"We will never share your data without your permission.",
    },
    {
        title:"Privacy",
        icon: <Icon icon="ic:round-lock" />,
        info:"We will never share your data without your permission.",
    },
]

export const toggleBotInfo = [
    {
        title: "Lending money for you investment",
        info: "Aspernatur atque voluptas quaerat veritatis voluptatum sint labore esse at voluptatem architecto quasi, praesentium corrupti adipisci voluptates dolorum iure cum rem? Dolor cumque architecto ratione consequuntur aspernatur animi numquam delectus, doloribus est quidem ipsam omnis quas quod maiores ipsa iste officiis aliquam fugiat vitae saepe cupiditate facilis. Velit reprehenderit ab praesentium repellat?"
    },
    {
        title: "Flexible mobile payments for investors",
        info: "Aspernatur atque voluptas quaerat veritatis voluptatum sint labore esse at voluptatem architecto quasi, praesentium corrupti adipisci voluptates dolorum iure cum rem? Dolor cumque architecto ratione consequuntur aspernatur animi numquam delectus, doloribus est quidem ipsam omnis quas quod maiores ipsa iste officiis aliquam fugiat vitae saepe cupiditate facilis. Velit reprehenderit ab praesentium repellat?"
    },
    {
        title: "Low fees & no hidden cost",
        info: "Aspernatur atque voluptas quaerat veritatis voluptatum sint labore esse at voluptatem architecto quasi, praesentium corrupti adipisci voluptates dolorum iure cum rem? Dolor cumque architecto ratione consequuntur aspernatur animi numquam delectus, doloribus est quidem ipsam omnis quas quod maiores ipsa iste officiis aliquam fugiat vitae saepe cupiditate facilis. Velit reprehenderit ab praesentium repellat?"
    },
    {
        title: "We speak your language",
        info: "Aspernatur atque voluptas quaerat veritatis voluptatum sint labore esse at voluptatem architecto quasi, praesentium corrupti adipisci voluptates dolorum iure cum rem? Dolor cumque architecto ratione consequuntur aspernatur animi numquam delectus, doloribus est quidem ipsam omnis quas quod maiores ipsa iste officiis aliquam fugiat vitae saepe cupiditate facilis. Velit reprehenderit ab praesentium repellat?"
    },
    {
        title: "Simple gateway to crypto",
        info: "Aspernatur atque voluptas quaerat veritatis voluptatum sint labore esse at voluptatem architecto quasi, praesentium corrupti adipisci voluptates dolorum iure cum rem? Dolor cumque architecto ratione consequuntur aspernatur animi numquam delectus, doloribus est quidem ipsam omnis quas quod maiores ipsa iste officiis aliquam fugiat vitae saepe cupiditate facilis. Velit reprehenderit ab praesentium repellat?"
    },
]
export const botRatings = [
    {
        icon: <Icon icon="uis:star" />,
        title: "“The best trading website”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Patrik"
    },
    {
        icon: <Icon icon="uis:star" />,
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Anonymous"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“I am loving it”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Victor"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“It's easly to make money here”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Anonymous"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“It's easly to make money here”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Patrik"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“It's easly to make money here”",
        name: "Anonymous"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“It's easly to make money here”",
        para: "Amazing letting agents. Joe was very helpful and professional, Chelsea answered our queries patiently. Thank you Danhamz",
        name: "Patrik"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“It's easly to make money here”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Patrik"
    },
    {
        icon: <Icon icon="uis:star" />,
        title: "“It's easly to make money here”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Patrik"
    },{
        icon: <Icon icon="uis:star" />,
        title: "“It's easly to make money here”",
        para: "Joseph had been great throughout the process. Communication has been regular and consistent, and he’s gone above and beyond to…",
        name: "Patrik"
    },
]